/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_Ready_HintInputs */

const en_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online scheduling, 24/7.`)
};

const es_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservas en línea, 24/7.`)
};

const de_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online-Terminplanung rund um die Uhr.`)
};

const zh_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在线预约，全天候。`)
};

const ar_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جدولة عبر الإنترنت على مدار الساعة.`)
};

const fr_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planification en ligne, 24h/24 et 7j/7.`)
};

const vi_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đặt lịch trực tuyến, 24/7.`)
};

const sw_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuratibu mtandaoni, 24/7.`)
};

const th_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตั้งเวลาออนไลน์ 24/7`)
};

const bs_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online zakazivanje, 24/7.`)
};

const ja_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オンラインスケジューリング、24/7。`)
};

const ko_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`온라인 스케줄링, 24/7.`)
};

const pt_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agendamento online, 24/7.`)
};

const it_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programmazione online, 24 ore su 24.`)
};

const sv_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online schemaläggning, 24/7.`)
};

const nl_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online planning, 24/7.`)
};

const da_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online planlægning, 24/7.`)
};

const nb_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online planlegging, 24/7.`)
};

const fi_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online aikataulu, 24/7.`)
};

const pl_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezerwacja online, 24/7.`)
};

const ru_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Онлайн расписание, 24/7.`)
};

const tr_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online zamanlama, 7/24.`)
};

const hi_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑनलाइन शेड्यूलिंग, 24/7।`)
};

const id_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadwal online, 24/7.`)
};

const ms_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempahan dalam talian, 24/7.`)
};

const cs_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On-line plánování,24 /7.`)
};

const el_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online κρατήσεις, 24/7.`)
};

const he_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תזמון מקוון, 24/7.`)
};

const af_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online planning, 24/7.`)
};

const hu_lessons_ready_hint = /** @type {(inputs: Lessons_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online foglalás, 24/7.`)
};

/**
* | output |
* | --- |
* | "Online scheduling, 24/7." |
*
* @param {Lessons_Ready_HintInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const lessons_ready_hint = /** @type {((inputs?: Lessons_Ready_HintInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_Ready_HintInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_lessons_ready_hint(inputs)
	if (locale === "de") return de_lessons_ready_hint(inputs)
	if (locale === "zh") return zh_lessons_ready_hint(inputs)
	if (locale === "ar") return ar_lessons_ready_hint(inputs)
	if (locale === "fr") return fr_lessons_ready_hint(inputs)
	if (locale === "vi") return vi_lessons_ready_hint(inputs)
	if (locale === "sw") return sw_lessons_ready_hint(inputs)
	if (locale === "th") return th_lessons_ready_hint(inputs)
	if (locale === "bs") return bs_lessons_ready_hint(inputs)
	if (locale === "ja") return ja_lessons_ready_hint(inputs)
	if (locale === "ko") return ko_lessons_ready_hint(inputs)
	if (locale === "pt") return pt_lessons_ready_hint(inputs)
	if (locale === "it") return it_lessons_ready_hint(inputs)
	if (locale === "sv") return sv_lessons_ready_hint(inputs)
	if (locale === "nl") return nl_lessons_ready_hint(inputs)
	if (locale === "da") return da_lessons_ready_hint(inputs)
	if (locale === "nb") return nb_lessons_ready_hint(inputs)
	if (locale === "fi") return fi_lessons_ready_hint(inputs)
	if (locale === "pl") return pl_lessons_ready_hint(inputs)
	if (locale === "ru") return ru_lessons_ready_hint(inputs)
	if (locale === "tr") return tr_lessons_ready_hint(inputs)
	if (locale === "hi") return hi_lessons_ready_hint(inputs)
	if (locale === "id") return id_lessons_ready_hint(inputs)
	if (locale === "ms") return ms_lessons_ready_hint(inputs)
	if (locale === "cs") return cs_lessons_ready_hint(inputs)
	if (locale === "el") return el_lessons_ready_hint(inputs)
	if (locale === "he") return he_lessons_ready_hint(inputs)
	if (locale === "af") return af_lessons_ready_hint(inputs)
	if (locale === "hu") return hu_lessons_ready_hint(inputs)
	return en_lessons_ready_hint(inputs)
});